import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LANDING_COLORS, landingEyebrowSx } from './landingTokens';

const PREVIEW_ROWS = [
  { time: '09:00', service: 'facial', status: 'confirmed', room: 1 },
  { time: '10:30', service: 'massage', status: 'membership', room: 2 },
  { time: '12:00', service: 'haircut', status: 'confirmed', room: 1 },
  { time: '14:15', service: 'manicure', status: 'walkIn', room: 3 },
];

const STATUS_COLORS = {
  confirmed: LANDING_COLORS.navy,
  membership: LANDING_COLORS.terracotta,
  walkIn: 'rgba(44, 42, 38, 0.35)',
};

const HeroAgendaPreview = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ position: 'relative', pr: { md: 1.5 }, pb: { md: 1.5 } }} aria-hidden>
      <Box
        sx={{
          position: 'absolute',
          display: { xs: 'none', md: 'block' },
          top: 22,
          right: 0,
          bottom: 0,
          left: 22,
          border: `1px solid ${LANDING_COLORS.onDark}`,
          opacity: 0.3,
          borderRadius: '16px',
        }}
      />
      <Paper
        elevation={0}
        sx={{
          position: 'relative',
          borderRadius: '16px',
          border: `1px solid ${LANDING_COLORS.line}`,
          background: LANDING_COLORS.paper,
          boxShadow: '0 30px 60px rgba(10, 18, 28, 0.35)',
          overflow: 'hidden',
          userSelect: 'none',
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ px: { xs: 2.5, md: 3 }, py: 2, borderBottom: `1px solid ${LANDING_COLORS.line}` }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: LANDING_COLORS.navy }}>
            {t('landing.hero.preview.title')}
          </Typography>
          <Typography component="span" sx={{ ...landingEyebrowSx, color: LANDING_COLORS.muted }}>
            {t('landing.hero.preview.meta')}
          </Typography>
        </Stack>

        {PREVIEW_ROWS.map((row, index) => (
          <Box
            key={row.time}
            sx={{
              display: 'grid',
              gridTemplateColumns: '52px 1fr auto',
              alignItems: 'center',
              gap: 2,
              px: { xs: 2.5, md: 3 },
              py: 1.75,
              borderBottom:
                index === PREVIEW_ROWS.length - 1 ? 'none' : `1px solid ${LANDING_COLORS.lineSoft}`,
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: '0.82rem',
                color: LANDING_COLORS.terracotta,
                fontVariantNumeric: 'tabular-nums',
              }}
            >
              {row.time}
            </Typography>
            <Box sx={{ minWidth: 0 }}>
              <Typography noWrap sx={{ fontWeight: 600, fontSize: '0.92rem', color: LANDING_COLORS.navy }}>
                {t(`landing.hero.preview.services.${row.service}`)}
              </Typography>
              <Typography sx={{ fontSize: '0.75rem', color: LANDING_COLORS.muted }}>
                {t('landing.hero.preview.room', { number: row.room })}
              </Typography>
            </Box>
            <Stack direction="row" spacing={0.75} alignItems="center">
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  background: STATUS_COLORS[row.status],
                }}
              />
              <Typography
                sx={{
                  fontSize: '0.68rem',
                  fontWeight: 700,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  color: LANDING_COLORS.muted,
                  whiteSpace: 'nowrap',
                }}
              >
                {t(`landing.hero.preview.statuses.${row.status}`)}
              </Typography>
            </Stack>
          </Box>
        ))}
      </Paper>
    </Box>
  );
};

export default HeroAgendaPreview;
